import { render, staticRenderFns } from "./TangYing.vue?vue&type=template&id=7ecf31fe"
import script from "./TangYing.vue?vue&type=script&lang=js"
export * from "./TangYing.vue?vue&type=script&lang=js"
import style0 from "./TangYing.vue?vue&type=style&index=0&id=7ecf31fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports